module.exports = __webpack_public_path__ + "static/media/1.a0887bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/baranovichi/1.jpg
// module id = 205
// module chunks = 0